import Vue from "vue";
import jwt_decode from "jwt-decode";

export const notify = (title, text, type) => {
  Vue.notify(title, text, type);
};

export const closeNotify = (notify) => {
  Vue.closeNotify(notify);
};

export const showError = (title, text) => {
  notify(title, text, "error");
};
export const showWarn = (title, text) => {
  notify(title, text, "warning");
};
export const showSuccess = (title, text) => {
  notify(title, text, "success");
};

export const showInfo = (title, text) => {
  notify(title, text, "info");
};

export const getTokenData = () => {
  var token = localStorage.getItem("token");
  var decode = jwt_decode(token);
  return decode;
};
export const colorsForChart = [
  "#3366cc",
  "#dc3912",
  "#ff9900",
  "#109618",
  "#990099",
  "#0099c6",
  "#dd4477",
  "#66aa00",
  "#b82e2e",
  "#316395",
  "#994499",
  "#22aa99",
  "#aaaa11",
  "#6633cc",
  "#e67300",
  "#8b0707",
  "#651067",
  "#329262",
  "#5574a6",
  "#3b3eac",
  "#b77322",
  "#16d620",
  "#b91383",
  "#f4359e",
  "#9c5935",
  "#a9c413",
  "#2a778d",
  "#668d1c",
  "#bea413",
  "#0c5922",
  "#743411",
];

const colors = {};
export const resetColorForChart = (name) => {
  colors[name] = 0;
};
export const getNextColorForChart = (name) => {
  let length = colorsForChart.length;
  let index = colors[name];
  if (index + 1 === length) {
    index = 0;
  }
  colors[name] = index + 1;
  return colorsForChart[index];
};

export const queueStatusDisplayMode = [
  {
    text: "Prosty",
    value: "Simple",
  },
  {
    text: "Rozszerzony",
    value: "Extended",
  },
  {
    text: "Prosty - alfabetycznie",
    value: "SimpleAlphabetOrder",
  },
  {
    text: "Rozszerzony - alfabetycznie",
    value: "ExtendedAlphabetOrder",
  },
];

export const reservationMode = [
  {
    text: "Anonimowy",
    value: "Anonymous",
  },
  {
    text: "Osobowy",
    value: "Personal",
  },
  {
    text: "Mieszany",
    value: "Mixed",
  },
];

export const propertyValidatorTypes = [
  {
    text: "Brak",
    value: 0,
  },
  {
    text: "Numer",
    value: 1,
  },
  {
    text: "Email",
    value: 2,
  },
  {
    text: "Numer telefonu",
    value: 3,
  },
  {
    text: "Wymagany",
    value: 4,
  },
  {
    text: "Regex",
    value: 5,
  },
  {
    text: "Minimalna długość",
    value: 6,
  },
  {
    text: "Maksymalna długość",
    value: 7,
  },
];

export const smsApiType = [
  {
    value: "0",
    text: "SmsApi",
  },
  {
    value: "1",
    text: "SerwerSMS",
  },
  {
    value: "2",
    text: "MultiInfo",
  },
];

export const captchaProvider = [
  {
    value: "0",
    text: "hCaptcha",
  },
  {
    value: "1",
    text: "Cloudflare Turnstile",
  },
];

export const randomColor = () => {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
};
